import { accountRequests } from "api/accountApi";
import { candidateRequests } from "api/candidateApi";
import React from "react";
import { AutocompleteArrayInput, AutocompleteInput, ReferenceArrayInput, TextInput } from "react-admin";

const getCandidaciesFilters = () => {
  const candidaciesFilters = [
    <TextInput
      label="Входящ номер"
      source="number"
      alwaysOn
    />,
    <TextInput
      label="Име или фамилия"
      source="names"
      alwaysOn
    />,
    <TextInput
      label="ЕГН"
      source="personId"
      alwaysOn
    />,
    <ReferenceArrayInput
      reference={candidateRequests.getCandidacieStatesSelect()}
      name="stateIds"
      source="stateIds"
      alwaysOn
    >
      <AutocompleteArrayInput label="Статус" />
    </ReferenceArrayInput>,
    <ReferenceArrayInput
      label="Заключени от"
      reference={accountRequests.getUsersSelect()}
      name="lockerUserId"
      source="lockerUserId"
      filter={{ roles: "Employee" }}
    >
      <AutocompleteInput
        label="Заключени от"
        style={{ width: 300 }}
        optionText={rec =>
          rec.secondName ? `${rec.firstName} ${rec.secondName} ${rec.lastName}` : `${rec.firstName} ${rec.lastName}`
        }
      />
    </ReferenceArrayInput>,
    <ReferenceArrayInput
      reference={accountRequests.getUsersSelect()}
      label="Обработвани от"
      name="workerUserId"
      source="workerUserId"
      filter={{ roles: "Employee" }}
      alwaysOn
    >
      <AutocompleteInput
        style={{ width: 300 }}
        label="Обработвани от"
        filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        optionText={rec =>
          rec.secondName ? `${rec.firstName} ${rec.secondName} ${rec.lastName}` : `${rec.firstName} ${rec.lastName}`
        }
      />
    </ReferenceArrayInput>,
  ];
  return candidaciesFilters;
};

export default getCandidaciesFilters;
